module.exports = __webpack_public_path__ + "static/card2-ea46a76f477337085c51c692124fdabb.jpg";